export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const statusColor = (s) => {
  const map = {
    requested: "bg-amber-100 text-amber-800",
    confirmed: "bg-blue-100 text-blue-800",
    payment_pending: "bg-orange-100 text-orange-800",
    paid: "bg-emerald-100 text-emerald-800",
    delivered: "bg-indigo-100 text-indigo-800",
    active: "bg-emerald-100 text-emerald-800",
    return_requested: "bg-violet-100 text-violet-800",
    returned: "bg-slate-100 text-slate-700",
    completed: "bg-slate-200 text-slate-800",
    cancelled: "bg-rose-100 text-rose-800",
    overdue: "bg-red-100 text-red-800",
    open: "bg-amber-100 text-amber-800",
    assigned: "bg-blue-100 text-blue-800",
    in_progress: "bg-indigo-100 text-indigo-800",
    resolved: "bg-emerald-100 text-emerald-800",
    closed: "bg-slate-200 text-slate-800",
    rejected: "bg-rose-100 text-rose-800",
    new: "bg-blue-100 text-blue-800",
    contacted: "bg-indigo-100 text-indigo-800",
    interested: "bg-emerald-100 text-emerald-800",
    not_interested: "bg-rose-100 text-rose-800",
    converted: "bg-emerald-200 text-emerald-900",
    lost: "bg-slate-200 text-slate-700",
    pending: "bg-amber-100 text-amber-800",
    success: "bg-emerald-100 text-emerald-800",
  };
  return map[s] || "bg-slate-100 text-slate-700";
};
